document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".hpgpro").forEach(section => {

    const cards = section.querySelectorAll(".hpgpro__card");
    const btn = section.querySelector(".hpgpro__load");

    const desktopLimit = parseInt(section.dataset.desktopLimit || 6);
    const mobileLimit = parseInt(section.dataset.mobileLimit || 4);

    let expanded = false;

function render() {

  const isMobile = window.innerWidth <= 768;
  const limit = isMobile ? mobileLimit : desktopLimit;

  cards.forEach((card, i) => {

    const shouldShow = expanded || i < limit;

    if (!shouldShow) {
      card.style.display = "none";
      card.classList.remove("show");
      return;
    }

    card.style.display = "flex";

    // RESET FIRST (IMPORTANT FIX)
    card.classList.remove("show");

    requestAnimationFrame(() => {
      setTimeout(() => {
        card.classList.add("show");
      }, i * 20);
    });

  });

  if (btn) {
    btn.innerText = expanded ? "Show Less" : "Show More";
  }
}

    render();

   btn?.addEventListener("click", function () {
  expanded = !expanded;

  section.classList.toggle("expanded", expanded);

  render();
    });

    window.addEventListener("resize", function () {
      render();
    });

  });

});